import { Box, Typography } from '@mui/material'
import { blue, grey } from '../../colors'
import { styled } from '@mui/system'

// Define the prop type for status
interface StatusProps {
  status?: string
}

export const ControlsBox = styled(Box)<StatusProps>(({ status }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  padding: '4px 8px',
  borderRadius: '6px',
  border: `2px solid ${status === 'LIVE' ? '#ABEFC6' : status === 'PUBLISHED' ? '#E8E8E8' : '#E8E8E8'}`,
  backgroundColor: status === 'LIVE' ? '#E6FAF0' : status === 'PUBLISHED' ? '#fff' : '#fff',
  color: status === 'LIVE' ? '#067647' : status === 'PUBLISHED' ? '#364049ff' : '#364049ff',
  fontWeight: 'bold',
  height: '26px'
}))

export const StatusCircle = styled(Box)<StatusProps>(({ status }) => ({
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  backgroundColor: status === 'LIVE' ? '#067647' : status === 'PUBLISHED' ? '#364049ff' : '#364049ff',
  border: `2px solid ${status === 'LIVE' ? '#067647' : status === 'PUBLISHED' ? '#364049ff' : '#364049ff'}`,
  alignItems: 'center'
}))

export const SectionTitleTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '24px',
  color: blue[1100],
  marginBottom: '22px'
}))

export const InstructionTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '24px',
  color: blue[1100]
}))

export const InstructionBox = styled(Box)(({ theme }) => ({
  width: '548px',
  padding: '24px',
  border: `1px solid ${grey[350]}`,
  borderRadius: '12px',
  background: '#FFF'
}))

export const QrCodeBox = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  padding: '20px',
  background: '#FFF'

}))

export const QrCodeSectionBox = styled(Box)(({ theme }) => ({
  textAlign: 'left',
  padding: '20px',
  width: '593px',
  border: `1px solid ${grey[350]}`,
  borderRadius: '12px',
  background: '#FFF'

}))

export const QrCodeTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '24px',
  color: blue[1100],
  background: '#FFF'

}))

export const QrCodeDescription = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '18px',
  color: grey[850],
  background: '#FFF'

}))

export const FooterTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '22px',
  color: blue[1100],
  marginTop: '22px'
}))
